import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'

import styles from './header-nav-bar.css'

const HeaderNavBar = ({ items }) => (
  <div styleName="header-nav-bar">
    {items && items.map(({ label, icon, secondary, active, onClick }, i) => (
      <div
        key={i}
        styleName={classNames('item', {
          'item-first': i === 0,
          'item-last': i === items.length - 1,
          'item-active': active,
          'item-primary': !active && !secondary,
          'item-secondary': secondary,
        })}
        onClick={onClick}
      >
        <span styleName="icon">{icon}</span>
        <span styleName="label">{label}</span>
      </div>
    ))}
  </div>
)

HeaderNavBar.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.any.isRequired,
      label: PropTypes.string.isRequired,
      active: PropTypes.bool,
      secondary: PropTypes.bool,
      onClick: PropTypes.func,
    })
  ),
}

export default CSSModules(HeaderNavBar, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/header-nav-bar/header-nav-bar.js
 **/